import { fork } from 'redux-saga/effects';

import { RootSagaReturnType } from '~types/saga';
import DiscountGateway from '~apis/discount';

import watchGetDiscountsSettings from './getDiscounts';
import watchCreateDiscountsSettings from './createDiscounts';
import watchUpdateDiscountsSettings from './updateDiscount';
import watchGetAllDiscountSettings from './getAllDiscount';

export default (api: DiscountGateway): RootSagaReturnType => {
    function* rootSaga() {
        yield fork(watchGetDiscountsSettings, api);
        yield fork(watchCreateDiscountsSettings, api);
        yield fork(watchUpdateDiscountsSettings, api);
        yield fork(watchGetAllDiscountSettings, api);
    }

    return {
        rootSaga,
    };
};
